import _ from "lodash";
import ObjectBuilding from "utils/objects/building";
import ObjectFloor from "utils/objects/floor";
import ObjectRoom from "utils/objects/room";
import ObjectClass from "utils/objects/object";
import ObjectTimeslot from 'utils/objects/timeslot'

const floorList = ({ building, floors, rooms }) => {
	const buildingFloors = ObjectClass.filterActive( ObjectFloor.get( building.floors ) );
	
	const result = [];
	_.forEach( ObjectFloor.order( buildingFloors ), floor => {
		if( !_.isEmpty( floors ) ) {
			floor = _.get( floors, floor.guid, {} );
		}
		
		const floorRooms = roomList({ floor, rooms } );
		if( _.size( ObjectTimeslot.parse( floor ) ) > 0 || _.size( floorRooms ) > 0 ) {
			result.push({
				...floor,
				rooms: floorRooms
			});
		}
	});
	
	return result;
}

const roomList = ({ floor, rooms }) => {
	const floorRooms = ObjectClass.filterActive( ObjectRoom.get( floor.rooms ) );
	
	const result = [];
	_.forEach( ObjectRoom.order( floorRooms ), room => {
		if( !_.isEmpty( rooms ) ) {
			room = _.get( rooms, room.guid, {} );
		}
		
		result.push( {
			...room,
		} );
	});
	
	return result;
}

const addToArray = ( array, item ) => {
	if( typeof _.find( array, { guid: item.guid } ) === 'undefined' ) {
		array.push( item );
	}
	
	return array;
}

export const buildingList = ({ buildings, floors, rooms, kinds = [] }) => {
	const result = [];
	
	_.forEach( ObjectBuilding.order( buildings ), building => {
		if( _.isEmpty( kinds ) ) {
			return [];
		}
		
		// Check transport and lunch (do not need a floor/room)
		let addToList = false;
		_.forEach( building.timeslots_through, o => {
			if( _.includes( kinds, o?.kind ) ) {
				addToList = true;
				return false;
			}
		})
		
		// Init
		const buildingFloorsWithTimeslot = [];
		const floorRoomsWithTimeslots = [];
		
		const buildingFloors = floorList({ building, floors } );
		_.forEach( buildingFloors, ( floor ) => {
			_.forEach( floor.timeslots_through, o => {
				if( _.includes( kinds, o?.kind ) ) {
					addToArray( buildingFloorsWithTimeslot, floor );
					return false;
				}
			})
			
			const floorRooms = roomList({ floor, rooms });
			_.forEach( floorRooms, ( room ) => {
				_.forEach( room.timeslots_through, o => {
					if( _.includes( kinds, o?.kind ) ) {
						addToArray( floorRoomsWithTimeslots, room );
						addToArray( buildingFloorsWithTimeslot, floor );
						return false;
					}
				})
			});
		});
		
		// When data is set add it to the building list
		if( addToList || _.size( buildingFloorsWithTimeslot ) > 0 || _.size( floorRoomsWithTimeslots ) > 0 ) {
			result.push({
				...building,
				floors: buildingFloorsWithTimeslot,
				rooms: floorRoomsWithTimeslots
			})
		}
	});
	
	return result;
}
